import React from 'react';

import { cn } from '@change/ds-utils';

import { Card, CardBody, CardHeader } from '@change/ds-core-ui/next';

import type { Platform } from '../../../../../shared/constants';
import { PlatformIcon } from '../../../../common/PlatformIcon';

/**
 * Platform card skeleton component for displaying loading state with platform-specific badge.
 */
export const PlatformCardSkeleton: React.FC<Props> = ({
	platform,
	placeholderColor,
	containerHeight = 168,
	imageHeight = 104,
}) => {
	return (
		<div
			data-platform={platform}
			data-testid={`placeholder-social-card-${platform}`}
			className="relative snap-center"
			aria-hidden="true"
		>
			<PlatformIcon platform={platform} />
			<Card
				className="elevation-low flex h-full flex-col rounded-xl border-[1.5px] bg-white [--card-gap:0px] orientation-vertical:w-[124px] orientation-vertical:lg:w-36"
				style={{ maxHeight: `${containerHeight}px` }}
				orientation="vertical"
			>
				<>
					<CardHeader variant="media" style={{ height: `${imageHeight}px` }}>
						<div
							className={cn('flex h-full w-full animate-pulse items-center justify-center', placeholderColor)}
							style={{ minHeight: `${imageHeight}px` }}
						/>
					</CardHeader>

					<CardBody className="flex flex-col gap-1.5 px-3 pt-3">
						<div className={cn('h-[18px] w-full animate-pulse rounded', placeholderColor)} />
						<div className={cn('h-[14px] w-4/5 animate-pulse rounded', placeholderColor)} />
					</CardBody>
				</>
			</Card>
		</div>
	);
};

type Props = Readonly<{
	platform: Platform;
	placeholderColor: string;
	containerHeight?: number;
	imageHeight?: number;
}>;
